__turbopack_context__.v({
  "className": "caveat_b788b018-module__1u1Uhq__className",
});
